import React from 'react';
import AffiliateContainer from '@src/containers/Affiliate';

const Affiliate = () => <AffiliateContainer />;

export default Affiliate;
